// extracted by mini-css-extract-plugin
export var container = "gY_f";
export var description = "gY_c";
export var logoContainer = "gY_ml";
export var socialsContainer = "gY_pH";